import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const LoginRedirect = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center py-6 border-t border-border">
      <p className="text-sm text-muted-foreground mb-4">
        Already have an account?
      </p>
      <Button
        variant="ghost"
        size="default"
        onClick={() => navigate('/user-login')}
        iconName="LogIn"
        iconPosition="left"
      >
        Sign In to Your Account
      </Button>
    </div>
  );
};

export default LoginRedirect;